<template>
    <div>
        <b-row class="my-3">
            <b-col cols="12" md="3"
                ><app-autocomplete
                    :get-object="false"
                    :items="clients"
                    label="Cliente"
                    v-model="filters.clientId"
                ></app-autocomplete
            ></b-col>
            <b-col cols="12" md="3"
                ><app-autocomplete
                    :get-object="false"
                    :items="clientTypes"
                    label="Tipo de cliente"
                    v-model="filters.clientTypeId"
                ></app-autocomplete
            ></b-col>
            <b-col cols="12" md="3"
                ><app-autocomplete
                    :get-object="false"
                    :items="cities"
                    label="Ciudad"
                    v-model="filters.cityId"
                ></app-autocomplete
            ></b-col>
            <b-col cols="12" md="3"
                ><app-autocomplete
                    :get-object="false"
                    :items="executives"
                    label="Ejecutivo"
                    v-model="filters.userId"
                ></app-autocomplete
            ></b-col>
        </b-row>
        <!-- Buttons -->

        <b-row>
            <b-col class="d-flex justify-content-end">
                <b-btn variant="primary" class="mr-2" @click="loadClients"
                    ><i class="fa fa-filter"></i
                ></b-btn>
                <b-btn variant="secondary" @click="clearFilters"
                    ><i class="fa fa-times"></i
                ></b-btn>
            </b-col>
        </b-row>
        <!-- /Buttons -->
        <b-row align-v="end" v-if="!!clientItems.length">
            <b-col class="d-flex justify-content-end">
                <b-btn variant="link" @click="selectAll">Todos</b-btn>
                |
                <b-btn variant="link" @click="selectNone">Ninguno</b-btn>
            </b-col>
        </b-row>
        <div>
            <b-row
                v-for="(client, i) in clientItems"
                :key="`client-${client.id}`"
                :class="i % 2 === 0 ? 'odd' : 'even'"
                class="my-2"
            >
                <b-col>{{ client.name }}</b-col>
                <b-col>
                    <b-row
                        v-for="(venue, j) in client.venues"
                        :key="`venue-${venue.id}`"
                        class="my-2"
                        :class="j % 2 === 0 ? 'odd2' : 'even2'"
                    >
                        <b-col>{{ venue.name }}</b-col>
                        <b-col>
                            <b-row
                                v-for="structure in venue.structures"
                                :key="`structure-${structure.id}`"
                            >
                                <b-col
                                    ><b-form-checkbox
                                        :value="structure.id"
                                        v-model="destinations"
                                        :name="`structure-${structure.id}`"
                                        :id="`structure-${structure.id}`"
                                        >{{ structure.name }}</b-form-checkbox
                                    ></b-col
                                >
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    data: () => ({
        filters: {
            clientId: '',
            cityId: '',
            userId: '',
            clientTypeId: '',
        },
        clientItems: [],
        destinations: [],
    }),
    watch: {
        destinations(val) {
            this.$emit('input', val)
        },
    },
    computed: {
        ...mapGetters(['clients', 'executives', 'cities', 'clientTypes']),
    },
    methods: {
        async loadClients() {
            const { data } = await this.$repo.get(
                'clients/hierarchy',
                this.filters
            )
            this.clientItems = data
        },
        clearFilters() {
            _.forIn(this.filters, (value, key) => (this.filters[key] = ''))
            this.loadClients()
        },
        selectAll() {
            this.clientItems.map(client =>
                client.venues.map(venue =>
                    venue.structures.map(structure =>
                        this.destinations.push(structure.id)
                    )
                )
            )
        },
        selectNone() {
            this.destinations = []
        },
        reset() {
            this.destinations = []
            this.clientItems = []
            _.forIn(this.filters, (value, key) => (this.filters[key] = ''))
        },
    },
    mounted() {
        this.load('clients')
        this.load('executives')
        this.load('cities')
        this.load('clientTypes')
    },
}
</script>
<style scoped>
.odd {
    background-color: #c6d4e1;
}
.even {
    background-color: #ebe7e0;
}
.odd2 {
    background-color: #bdb8ad;
}
.even2 {
    background-color: #ffffff;
}
</style>
